import { ModuleWithProviders, NgModule } from '@angular/core';

import { HumanresourcesPublicSharedComponent } from './humanresources-public-shared.component';

@NgModule({
    declarations: [HumanresourcesPublicSharedComponent],
    imports: [],
    exports: [HumanresourcesPublicSharedComponent],
})
export class HumanresourcesPublicSharedModule {
    static forRoot(): ModuleWithProviders<HumanresourcesPublicSharedModule> {
        return {
            ngModule: HumanresourcesPublicSharedModule,
        };
    }
}
